import _ from 'underscore';
import PropTypes from 'prop-types';

export const goalStatus = {
  Active: 'Active',
  Unknown: 'Unknown',
  Deleted: 'Deleted',
};

export const goalSetupStatus = {
  None: 'None',
  ClaritySetupPending: 'ClaritySetupPending',
  ManualSetupPending: 'ManualSetupPending',
};

export const tagStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Unverified: 'Unverified',
};

export const goalTrackingStatus = {
  Unverified: 'Unverified',
  NoRecentConversion: 'NoRecentConversion',
  RecordingConversions: 'RecordingConversions',
  TagInactive: 'TagInactive',
  InactiveDueToTagUnavailable: 'InactiveDueToTagUnavailable',
};

export const audienceTrackingStatus = {
  Ready: 'Ready',
  BuildingTheAudience: 'BuildingTheAudience',
  AudienceTooSmall: 'AudienceTooSmall',
  NoActivityInThePast24Hrs: 'NoActivityInThePast24Hrs',
  MissingTagOnTheSite: 'MissingTagOnTheSite',
  MissingCustomEventsOnTheTag: 'MissingCustomEventsOnTheTag',
  ReadyForAudienceCampaignNotSearchCampaign: 'ReadyForAudienceCampaignNotSearchCampaign',
  ReadyForSearchCampaignNotAudienceCampaign: 'ReadyForSearchCampaignNotAudienceCampaign',
  InactiveDueToTagUnavailable: 'InactiveDueToTagUnavailable',
};

export const eventTypes = {
  DestinationGoal: 'DestinationGoal',
  EventGoal: 'EventGoal',
};

export const revenueTypes = {
  FixedValue: 'FixedValue',
  VariantValue: 'VariantValue',
  NoValue: 'NoValue',
};

export const goalCategories = {
  Unknown: 'Unknown',
  None: 'None',
  Purchase: 'Purchase',
  AddToCart: 'AddToCart',
  BeginCheckout: 'BeginCheckout',
  Subscribe: 'Subscribe',
  SubmitLeadForm: 'SubmitLeadForm',
  BookAppointment: 'BookAppointment',
  Signup: 'Signup',
  RequestQuote: 'RequestQuote',
  GetDirections: 'GetDirections',
  OutboundClick: 'OutboundClick',
  Contact: 'Contact',
  PageView: 'PageView',
  Download: 'Download',
  Other: 'Other',
};

export const expressionOperator = {
  EqualsTo: 'EqualsTo',
  Contains: 'Contains',
  StartsWith: 'StartsWith',
  RegularExpression: 'RegularExpression',
};

export const errorPropType = PropTypes.arrayOf(PropTypes.shape({
  Code: PropTypes.string,
  Message: PropTypes.string,
  Property: PropTypes.string,
}));

export const conversionAppProp = PropTypes.shape({
  isReadOnlyUser: PropTypes.bool.isRequired,
});

export const expressionOperatorsProp = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.oneOf(_.values(expressionOperator)).isRequired,
  value: PropTypes.string.isRequired,
}));

export const conversionTagProp = PropTypes.shape({
  isInitialized: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: errorPropType,
  data: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.oneOf(['Container', 'DMC', 'UET']),
    status: PropTypes.oneOf(_.values(tagStatus)),
    createdDateTime: PropTypes.string,
  }),
  getTag: PropTypes.func.isRequired,
  createTag: PropTypes.func.isRequired,
});

export const goalPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  url: PropTypes.string,
  expressionOperator: PropTypes.oneOf(_.values(expressionOperator)),
  status: PropTypes.oneOf(_.values(goalStatus)),
  tagId: PropTypes.string,
  eventType: PropTypes.oneOf(_.values(eventTypes)).isRequired,
  action: PropTypes.string,
  actionOperator: PropTypes.oneOf(['EqualsTo']),
  goalCategory: PropTypes.string,
  goalValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  goalValueType: PropTypes.oneOf(_.values(revenueTypes)).isRequired,
  currencyCode: PropTypes.string,
  trackingClient: PropTypes.oneOf(['DefaultClient', 'SmartPages']),
  goalSetupStatus: PropTypes.oneOf(_.values(goalSetupStatus)),
  clarityEventDefinitionId: PropTypes.string,
  clarityEventDefinitionObject: PropTypes.shape({}),
});

export const conversionGoalProp = PropTypes.shape({
  isLoading: PropTypes.bool.isRequired,
  error: errorPropType,
  data: PropTypes.arrayOf(goalPropType),
  urlExpressionOperators: expressionOperatorsProp.isRequired,
  getGoals: PropTypes.func.isRequired,
  setGoal: PropTypes.func.isRequired,
});

export const metricsPropType = PropTypes.shape({
  totalTimeSpent: PropTypes.number,
  totalPagesViewed: PropTypes.number,
  totalSessions: PropTypes.number,
  totalClicks: PropTypes.number,

  metrics: PropTypes.arrayOf(PropTypes.shape({
    goalId: PropTypes.number,
    goalName: PropTypes.string,
    goalUrl: PropTypes.string,
    goalOperator: PropTypes.oneOf(_.values(expressionOperator)),
    conversions: PropTypes.number,
    assists: PropTypes.number,
  })),
});

export const conversionMetricProp = PropTypes.shape({
  audienceData: metricsPropType,
  isLoading: PropTypes.bool.isRequired,
  error: errorPropType,
  socialData: metricsPropType,
  searchData: metricsPropType,
  getMetrics: PropTypes.func.isRequired,
});

export const instrumentationProp = PropTypes.shape({
  logError: PropTypes.func.isRequired,
  logTrace: PropTypes.func.isRequired,
  logMetrics: PropTypes.func.isRequired,
});

export const conversionPreferencesProp = PropTypes.shape({
  getPreference: PropTypes.func.isRequired,
  setPreference: PropTypes.func.isRequired,
});

